module.exports = __webpack_public_path__ + "img/ResidentControl3.70fe5cb0.png";